import React from "react";
type LogoProps = {
  color?: "dark" | "light";
  height?: number;
  src: string;
};
const Logo: React.FC<LogoProps> = ({ src, color = "light", height = 68 }) => {
  return <img src={src} alt="logo" height={height} />;
};

export default Logo;
